import React from 'react';
import { render, fireEvent, waitFor } from '@testing-library/react';
import ThemesLayout from './themes_layout';

// Mock axios
jest.mock('../../global/axios', () => ({
    get: jest.fn(),
    post: jest.fn(),
    put: jest.fn(),
    delete: jest.fn(),
}));

import axios from '../../global/axios';

describe('ThemesLayout', () => {
    beforeEach(() => {
        jest.clearAllMocks();
        axios.get.mockResolvedValue({ data: [] });
    });

    it('renders the Themes heading', async () => {
        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('Themes')).toBeTruthy());
    });

    it('shows upload button', async () => {
        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('Upload .protheme')).toBeTruthy());
    });

    it('shows empty state when no themes', async () => {
        axios.get.mockResolvedValue({ data: [] });
        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('No themes uploaded yet')).toBeTruthy());
    });

    it('shows loading state initially', () => {
        axios.get.mockReturnValue(new Promise(() => {})); // never resolves
        const { getByText } = render(<ThemesLayout />);
        expect(getByText('Loading themes...')).toBeTruthy();
    });

    it('renders theme list when themes exist', async () => {
        axios.get.mockResolvedValue({
            data: [{
                id: 1, name: 'Test Theme', is_default: true, source_filename: 'test.protheme',
                slides: [{ slide_type: 'point', font_name: 'Avenir', font_size: 90, text_color: { r: 1, g: 1, b: 1, a: 1 } }]
            }]
        });
        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('Test Theme')).toBeTruthy());
    });

    it('shows Active badge on default theme', async () => {
        axios.get.mockResolvedValue({
            data: [{ id: 1, name: 'Active Theme', is_default: true, slides: [] }]
        });
        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('Active')).toBeTruthy());
    });

    it('shows Activate button on non-default theme', async () => {
        axios.get.mockResolvedValue({
            data: [{ id: 1, name: 'Inactive', is_default: false, slides: [] }]
        });
        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('Activate')).toBeTruthy());
    });

    it('calls delete when Delete button clicked and confirmed', async () => {
        axios.get.mockResolvedValue({
            data: [{ id: 1, name: 'To Delete', is_default: false, slides: [] }]
        });
        axios.delete.mockResolvedValue({});
        window.confirm = jest.fn(() => true);

        const { getByText } = render(<ThemesLayout />);
        await waitFor(() => expect(getByText('Delete')).toBeTruthy());
        fireEvent.click(getByText('Delete'));

        expect(axios.delete).toHaveBeenCalledWith('/slides/themes/1.json');
    });
});
